import { EVENT_STATUS } from "../constants/constants";
import { IEasyClockEvent } from "../services/easyclock/interfaces";

export const shouldRenderInfo = (event: IEasyClockEvent, showIgnored:boolean, showAdded: boolean) => {
  return (event.status == EVENT_STATUS.IGNORED && showIgnored === true) || (event.status == EVENT_STATUS.ADDED && showAdded === true) || (event.status == EVENT_STATUS.PENDING);
}